import React from 'react';
import env from 'config/environment';
import store from 'services/store';
import { RootState } from 'types/state';
import './DebugRender.scss';

interface OwnProps {
  /**
   * Parent is the parent component of DebugRender. Assign the value of {this}
   * into parent and DebugRender will do the rest.
   */
  parent: any
}

type Props = OwnProps

/**
 * DebugRender is a helper component that can identify components that have
 * excessive renders. By default, this component does not render anything. To
 * enable rendering this component, you'll need to enable 'showRenderDebugger'
 * under settings.
 */
class DebugRender extends React.Component<Props> {
  // This is intentional, as connect prevents this component from rendering.
  showRenderDebugger = env.IsDevelopment() === true
    && (store.getState() as RootState).settings.development.showRenderDebugger;

  counter = 0;

  static defaultProps = {
    uniqueName: '',
    componentName: '',
  };

  render() {
    if (this.showRenderDebugger !== true) { return null; }

    const name = this.props.parent?._reactInternalFiber?.elementType?.name ?? '';
    const attr = this.props.parent?.props?.attribute ?? '';

    this.counter++;
    return (
      <span className="debugRender">
        {name} - {this.counter}
        <span>{attr}</span>
      </span>
    );
  }
}

export default DebugRender;
